import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.594 4.75c.246 0 .492.164.601.41.082.246.028.547-.136.711L8.992 6.937l1.586 1.614A1.96 1.96 0 0 0 12 9.125c.52 0 1.012-.191 1.395-.574l3.609-3.61a.644.644 0 0 1 .902 0c.274.274.274.684 0 .93l-3.582 3.61a3.25 3.25 0 0 1-2.324.957 3.3 3.3 0 0 1-2.352-.958L8.063 7.867 6.996 8.934a.74.74 0 0 1-.738.164c-.246-.11-.383-.356-.383-.63V5.407c0-.355.273-.656.656-.656zm-4.95 13.398-.957-1.695c-.273-.465-.246-1.039.137-1.394C5.22 13.664 8.117 11.75 12 11.75c3.855 0 6.754 1.914 8.148 3.309.383.355.41.93.165 1.394l-.985 1.695c-.191.356-.629.52-1.012.41l-3.09-.93a.85.85 0 0 1-.601-.82V15.25a8.6 8.6 0 0 0-5.25 0v1.559c0 .382-.273.71-.629.82l-3.09.93c-.383.109-.82-.055-1.011-.41"
    }, null, -1)
  ]))]))
}
export default { render: render }